// Stable seed UUIDs for survey questions referenced from product code.
// Source: backend/src/db/seeds/surveyData.ts
// The "weight" question has nickname="weight" but the blood-pressure question
// has nickname=null in the seed, so we identify it by id here. If the seed
// ever rewrites these ids, update both sides together.

export const QUESTION_ID_WEIGHT = "f5b9911e-9328-46a8-a10e-39de950bee9b";
export const QUESTION_ID_HEIGHT = "3d5cc5c8-5e34-453a-baa8-9517fa93c917";
export const QUESTION_ID_WAIST = "3878267e-4597-4688-88a3-0b4ce3200600";
export const QUESTION_ID_BLOOD_PRESSURE =
  "43aa8eef-6b23-45b0-97c3-b69b6b327fd7";
